import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { EventAcademy } from './event.model';

@Injectable()
export class EventAcademyService {

  private _eventAcademy: EventAcademy;

  constructor(private restAgenda : RestAgendaService) { }

  public get eventAcademy(): EventAcademy {
    return this._eventAcademy;
  }
  public set eventAcademy(value: EventAcademy) {
    this._eventAcademy = value;
  }

  createEventOrAcademy(event : FormData) : Observable<EventAcademy>{
    return this.restAgenda.createAgendaElement(event);
  }

  updateEventOrAcademy(event : FormData) : Observable<EventAcademy>{
    return this.restAgenda.updateAgendaElement(event);
  }

  deleteEventOrAcademy(id : number) : Observable<any> {
    return this.restAgenda.deleteAgendaElement(id);
  }

}
